"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateConcept = exports.mergeConcepts = exports.getConcepts = exports.getConceptById = exports.deleteConcept = exports.defaultConceptData = exports.createConcept = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultConceptData = exports.defaultConceptData = {
  id: 0,
  enabled: true,
  name: ''
};
const getConcepts = params => (0, _request.default)({
  url: '/concepts',
  method: 'get',
  params
});
exports.getConcepts = getConcepts;
const getConceptById = id => (0, _request.default)({
  url: `/concepts/${id}`,
  method: 'get'
});
exports.getConceptById = getConceptById;
const updateConcept = (id, data) => (0, _request.default)({
  url: `/concepts/${id}`,
  method: 'patch',
  data
});
exports.updateConcept = updateConcept;
const deleteConcept = id => (0, _request.default)({
  url: `/concepts/${id}`,
  method: 'delete'
});
exports.deleteConcept = deleteConcept;
const createConcept = data => (0, _request.default)({
  url: '/concepts/',
  method: 'post',
  data
});
exports.createConcept = createConcept;
const mergeConcepts = data => (0, _request.default)({
  url: '/concepts/merge',
  method: 'post',
  data
});
exports.mergeConcepts = mergeConcepts;